'use strict';
import { createFooterStore } from '@src/redux/store';
import { pick } from 'lodash';
import { renderComponent } from '@src/utils/renderer/client-renderer';
import { FooterLayout } from '../../views/layouts/footer';
import React from 'react';

const APP_ID = 'footer-section';
const app = document.getElementById(APP_ID);

if (app !== null && window.USE_LEGACY_HEADER_FOOTER_REDUX === 'true') {
    const store = createFooterStore(
        pick(window.REDUX_DATA, ['panelsReducer', 'contentPageReducer', 'marketplaceReducer'])
    );

    renderComponent(<FooterLayout />, {
        appId: APP_ID,
        store,
        enableQueryClient: true
    });
}
